const eventPassive = () => {
  let payload = false;

  try {
    const opts = Object.defineProperty({}, 'passive', {
      get() {
        payload = { passive: true };

        return true;
      },
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    payload = false;
  }

  return payload;
};

export default eventPassive;
